import { render, staticRenderFns } from "./PaymentReservationFormComponent.vue?vue&type=template&id=88aa0988&xmlns=true&"
import script from "./PaymentReservationFormComponent.vue?vue&type=script&lang=js&"
export * from "./PaymentReservationFormComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/neta-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('88aa0988')) {
      api.createRecord('88aa0988', component.options)
    } else {
      api.reload('88aa0988', component.options)
    }
    module.hot.accept("./PaymentReservationFormComponent.vue?vue&type=template&id=88aa0988&xmlns=true&", function () {
      api.rerender('88aa0988', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/neta/neta-attraction/basic-data/forms/payment-reservation-form/PaymentReservationFormComponent.vue"
export default component.exports